// Core
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import AddPhoto from "material-ui/svg-icons/image/add-a-photo";
import FlatButton from "material-ui/FlatButton";

// Components
import TemplatesChoiceFields from "./TemplatesChoiceFields";

// Actions
import {
  deleteImage,
  changeReportFields,
  getTemplatest
} from "../../redux/templates/actions";

// Selectors
import * as authSelectors from "../../redux/auth/selectors";

// Instruments
import { FileStackClient } from "../../services/FileStackService";
import uuid from "uuid";

class TemplatesSettings extends PureComponent {
  _handleUpload = () => {
    FileStackClient.picker({
      maxFiles: 1,
      fromSources: [
        "local_file_system",
        "googledrive",
        "dropbox",
        "gmail",
        "box",
        "onedrive",
        "clouddrive"
      ],
      onUploadDone: (res) => {
        const { filesUploaded } = res;
        const { handle } = filesUploaded[0];
        this.props.setLogo(handle);
      }
    }).open();
  };

  changeCategoryWithFields = (e) => {
    const { onActiveType, defaultFields, templateId, userId, getTemplatest, changeReportFields, setFieldsToActiveTemplate } = this.props;

      onActiveType(e).then((type) => {
          changeReportFields(userId, templateId, defaultFields[type]).then(() => {
              setFieldsToActiveTemplate(defaultFields[type]);
              getTemplatest(userId);
          });
      });
  }

  onSetReportFields = fields => {
    const {
      changeReportFields,
      userId,
      templateId,
      setFieldsToActiveTemplate,
      getTemplatest
    } = this.props;
    setFieldsToActiveTemplate(fields);
    changeReportFields(userId, templateId, fields).then(() => {
      getTemplatest(userId);
    });
  };

  render() {
    const {
      typeReport,
      types,
      logoId,
      deleteLogo,
      defaultFields,
      reportFields
    } = this.props;
    return (
      <div style={{ padding: "20px", overflowY: 'auto', height: 'calc(100vh - 120px)', width: 'calc(100vw - 381px)'}}>
        <div className="checklist-select template-select-category">
          <select
            style={{ cursor: "pointer" }}
            className="select-text template-select-text"
            value={typeReport}
            onChange={this.changeCategoryWithFields}
          >
            {types.map(category => (
              <option key={category.value} value={category.value}>
                {category.label}
              </option>
            ))}
          </select>
          <span className="select-highlight" />
          <span className="select-bar" />
        </div>
        <div className="template-creator-info template-creator-info-select">
          This choice defined if reports created with this template will have
          table format or detailed format
        </div>
        <div style={{ display: "flex", marginTop: "60px" }}>
          <div>
            {logoId ? (
              <FlatButton
                onClick={deleteLogo}
                label="Delete Logo"
                labelStyle={{ color: "#f44336" }}
              />
            ) : (
              <div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <AddPhoto />
                  <FlatButton
                    onClick={this._handleUpload}
                    label="Upload Logo"
                  />
                </div>
                <div className="template-creator-info template-creator-info-select">
                  Upload company logo and this logo will appear in the report
                </div>
              </div>
            )}
          </div>
          <div style={{ width: "300px", height: "300px" }}>
            {logoId && (
              <img
                src={`https://cdn.filestackcontent.com/${logoId}`}
                alt="logo"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                  overflow: "hidden"
                }}
              />
            )}
          </div>
        </div>
        <TemplatesChoiceFields
          defaultFields={defaultFields}
          typeReport={typeReport}
          reportFields={reportFields}
          onSetReportFields={this.onSetReportFields}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  accessToken: authSelectors.getAccessToken(state),
  userId: authSelectors.getUserId(state)
});

const mapDispatchToProps = {
  deleteImage,
  changeReportFields,
  getTemplatest
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TemplatesSettings);
